import React from 'react';
import { GraduationCap, Microscope, BookOpen, FlaskConical, CheckCircle2, Phone, Award } from 'lucide-react';
import { CLINIC, FELLOWSHIP, IMAGES } from '../mock';
import { PageHero, SectionTitle, Reveal } from '../components/Shared';

const ICONS = [Microscope, Award, BookOpen, FlaskConical];

export default function FellowshipProgram() {
  return (
    <div>
      <PageHero eyebrow="Training & Academics" title="Rheumatology Fellowship Program" subtitle="Training the next generation of rheumatologists with hands-on clinical exposure and UK-standard mentorship." image={IMAGES.examRoom} />

      <section className="py-20">
        <div className="container-x grid lg:grid-cols-2 gap-14 items-center">
          <Reveal>
            <div className="rounded-[2rem] overflow-hidden shadow-2xl">
              <img src={IMAGES.consult} alt="Fellowship training" className="w-full h-[420px] object-cover" />
            </div>
          </Reveal>
          <div>
            <SectionTitle eyebrow="About the Program" title="Learn from a UK-trained consultant" />
            <p className="text-slate-600 leading-relaxed">{FELLOWSHIP.intro}</p>
            <div className="grid grid-cols-3 gap-4 mt-8">
              {[{ v: '12', l: 'Months' }, { v: '100+', l: 'Conditions' }, { v: '1:1', l: 'Mentorship' }].map((s) => (
                <div key={s.l} className="bg-teal-50 rounded-2xl p-5 text-center">
                  <div className="font-display text-2xl text-teal-800" style={{ fontWeight: 700 }}>{s.v}</div>
                  <div className="text-xs text-slate-500 mt-1">{s.l}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="mint-section py-20">
        <div className="container-x">
          <SectionTitle center eyebrow="Curriculum" title="What you'll gain" />
          <div className="grid md:grid-cols-4 sm:grid-cols-2 gap-6">
            {FELLOWSHIP.points.map((p, i) => {
              const Icon = ICONS[i % ICONS.length];
              return (
                <Reveal key={p.title} delay={i * 80}>
                  <div className="card-lift bg-white border border-teal-50 rounded-2xl p-7 h-full">
                    <span className="grid place-items-center w-14 h-14 rounded-2xl text-white mb-5" style={{ background: 'linear-gradient(135deg,#0f766e,#0b3b3a)' }}><Icon size={26} /></span>
                    <h3 className="text-base text-teal-900 mb-2" style={{ fontWeight: 600 }}>{p.title}</h3>
                    <p className="text-slate-600 text-sm leading-relaxed">{p.body}</p>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </section>

      <section className="py-20">
        <div className="container-x grid lg:grid-cols-2 gap-12 items-center">
          <div className="bg-white border border-teal-50 rounded-3xl p-8 shadow-sm">
            <h3 className="flex items-center gap-2 font-display text-2xl text-teal-900 mb-6" style={{ fontWeight: 600 }}><GraduationCap size={24} className="text-teal-600" /> Eligibility</h3>
            <ul className="space-y-4">
              {FELLOWSHIP.eligibility.map((e) => (
                <li key={e} className="flex gap-3 text-slate-700"><CheckCircle2 size={20} className="text-teal-600 shrink-0" /> {e}</li>
              ))}
            </ul>
          </div>
          <div>
            <SectionTitle eyebrow="Apply" title="Interested in applying?" sub="We welcome motivated physicians passionate about autoimmune and musculoskeletal medicine. Reach out to learn about the next intake." />
            <a href={`tel:${CLINIC.phoneRaw}`} className="btn-coral inline-flex items-center gap-2 px-7 py-3.5 rounded-full font-semibold"><Phone size={18} /> Enquire: {CLINIC.phone}</a>
          </div>
        </div>
      </section>
    </div>
  );
}
